import { MENU, SurveyDialogProps } from './type';

import ECardex from './ECardex';
import TakingOver from './TakingOver';
import Hospitalization from './Hospitalization';
import OutHospital from './OutHospital';
import Prescription from './Prescription';
import Nurse from './Nurse';
import Medication from './Medication';
import Radiology from './Radiology';
import Pathology from './Pathology';
import ClinicalObservation from './ClinicalObservation';
import Glucose from './Glucose';
import BedScore from './BedScore';
import BedScoreTwo from './BedScoreTwo';
import Fall from './Fall';
import FallTwo from './FallTwo';
import FallScale from './Humty Dumpty Fall Scale';
import GCS from './GCS';
import Pediatric_GCS from './Pediatric_GCS';
import FourScore from './Four Score';
import Needs from './Needs';
import Safety from './Safety';
import NRS from './Pain/NRS';
import FLACC from './Pain/FLACC';
import CNPS from './Pain/CNPS';
import MentalNursing from './MentalHealth/MentalNursing';
import BDI from './MentalHealth/BDI';
import BAI from './MentalHealth/BAI';
import MMSE from './MentalHealth/MMSE';
import CIST from './MentalHealth/CIST';
import Operation from './Special/Operation';
import Anesthesia from './Special/Anesthesia';
import Transfusion from './Special/Transfusion';
import CPR from './Special/CPR';
import Dialysis from './Special/Dialysis';
import Emergency from './Special/Emergency';
import Childbirth from './Special/Childbirth';
import HomeCare from './Special/HomeCare';
import DietList from './DietList';

import KPCS from './KPCSs/KPCS';

import HospitalizationInfo from './Agreement/HospitalizationInfo';
import FallPrevention from './Agreement/FallPrevention';
import Colonoscopy from './Agreement/Colonoscopy';
import UpperEndoscopy from './Agreement/UpperEndoscopy';
import NonSalary from './Agreement/NonSalary';
import MedicalRecords from './Agreement/MedicalRecords';
import DNR from './Agreement/DNR';
import DNA from './Agreement/DNA';
import CoreNursingSkillVideo from 'routes/CoreNursingSkillVideo';
import CoreNursingSkillVideoExemple from 'routes/CoreNursingSkillVideoExemple';
import DrugCalculatior from './DrugCalculator';
import NurseCheckListRoom from './NurseCheckList/ROOM';
import FFI from './Pain/FFI';
import KOOS from './Pain/KOOS';
import LEFS from './Pain/LEFS';
import NDI from './Pain/NDI';
import STarTBackScreening from './Pain/STarTBackScreening';
import TransfusionAgreement from './Agreement/Transfusion';
import IORecord from './IORecord';
import Suppressor from './Agreement/Suppressor';
import CRRT from './Agreement/CRRT';
import Intubation from './Special/Intubation';
import CentralVenous from './Agreement/CentralVenous';
import NursingRecord from './NursingRecord';
import KPCS_ICU from './KPCSs/KPCS_ICU';
import DNRTwo from './Agreement/DNRTwo';
import IntubationAgreement from './Agreement/Intubation';
import KPCSC from './KPCSs/KPCSC';
import KPCS_GW from './KPCSs/KPCS_GW';
import KDSQ_P from './MentalHealth/KDSQ_P';
import KDSQ_C from './MentalHealth/KDSQ_C';
import K_CPAT from './Pain/K_CPAT';
import PAINAD_K_Commu from './Pain/PAINAD_K(commu)';
import PAINAD_K_non from './Pain/PAINAD_K(non)';
import Clinicalobs_ICU from './Clinicalobs ICU';
import CoreNursingSkillVideoExempleTwo from 'routes/CoreNursingSkillVideoExempleTwo';
import FallThree from './FallThree';
import CoreNursingSkillVideoExempleThree from 'routes/CoreNursingSkillVideoExempleThree';
import MSE from './MentalHealth/MSE';
import CoreNursingSkillVideoExempleFour from 'routes/CoreNursingSkillVideoExempleFour';
import VoiceEMR from './VoiceEMR';
import NEWS2 from './NEWS2';
import BloodDischarge from './Special/BloodDischarge';
import RadiologyEtc from './RadiologyEtc';
import BedScoreThree from './BedScoreThree';
import BedScoreFour from './BedScoreFour';
import SBAR from './SBAR';
import SBAR2 from './SBAR2';
import SBAR3 from './SBAR3';
import NursingNeed from './NursingNeed';
import AdmissionAndDischarge from './Agreement/AdmissionAndDischarge';
import SelfDischarge from './Agreement/SelfDischarge';
import Infection from './Infection';
import Restraint from './Special/Restraint';
import NursingActivityPlan from './SimulationRecord/ActivityPlan/NursingActivityPlan';
import ProcessRecord from './SimulationRecord/ProcessRecord/ProcessRecord';
import PersonalAgreement from './SimulationRecord/PersonalAgreement/PersonalAgreement';
import SubmitAssignment from 'routes/SubmiAssignment';
import Debriefing from './SimulationRecord/Debriefing';
import MinorConsent from './Agreement/MinorConsent';
import ECMO from './Special/ECMO';
import ConsentForSurgery from './Agreement/ConsentForSurgery';
import Maturity from './Maturity';
import PatientLabel from '../DisplayInformation/PatientLabel';

interface Props {
  surveyType: string;
  onCloseSave: () => void;
  onCloseReadOnly: () => void;
  dialogProps: Omit<SurveyDialogProps<any>, 'onClose'>;
}

// PAGE: 사이드바 메뉴 표시
const DisplaySurvey = (props: Props) => {
  const { surveyType, onCloseSave, onCloseReadOnly, dialogProps } = props;

  const { defaultValues } = dialogProps;

  switch (surveyType) {
    case MENU.E_CARDEX: {
      if (!defaultValues) return null;
      return <ECardex {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.TAKING_OVER: {
      if (!defaultValues) return null;
      return <TakingOver {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SBAR: {
      if (!defaultValues) return null;
      return <SBAR {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SBAR2: {
      if (!defaultValues) return null;
      return <SBAR2 {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SBAR3: {
      if (!defaultValues) return null;
      return <SBAR3 {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.HOSPITALIZATION: {
      if (!defaultValues) return null;
      return <Hospitalization {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.OUT_HOSPITAL: {
      if (!defaultValues) return null;
      return <OutHospital {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.PRESCRIPTION: {
      return <Prescription {...dialogProps} onClose={onCloseReadOnly} />;
    }
    case MENU.NURSE: {
      return <Nurse {...dialogProps} onClose={onCloseReadOnly} />;
    }
    case MENU.MEDICATION: {
      if (!defaultValues) return null;
      return <Medication {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.RADIOLOGY: {
      if (!defaultValues) return null;
      return <Radiology {...dialogProps} onClose={onCloseReadOnly} />;
    }
    case MENU.PATHOLOGY: {
      if (!defaultValues) return null;
      return <Pathology {...dialogProps} onClose={onCloseReadOnly} />;
    }
    case MENU.CLINICAL_OBSERVATION: {
      if (!defaultValues) return null;
      return <ClinicalObservation {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CLINICAL_OBSERVATION_ICU: {
      if (!defaultValues) return null;
      return <Clinicalobs_ICU {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.GLUCOSE: {
      if (!defaultValues) return null;
      return <Glucose {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.IORECORD: {
      if (!defaultValues) return null;
      return <IORecord {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NEWS2: {
      if (!defaultValues) return null;
      return <NEWS2 {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.BEDSORES: {
      if (!defaultValues) return null;
      return <BedScore {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.BEDSORESTWO: {
      if (!defaultValues) return null;
      return <BedScoreTwo {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.BEDSORESTHREE: {
      if (!defaultValues) return null;
      return <BedScoreThree {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.BEDSORESFOUR: {
      if (!defaultValues) return null;
      return <BedScoreFour {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NEEDS: {
      if (!defaultValues) return null;
      return <Needs {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FALL: {
      if (!defaultValues) return null;
      return <Fall {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FALLTWO: {
      if (!defaultValues) return null;
      return <FallTwo {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FALLTHREE: {
      if (!defaultValues) return null;
      return <FallThree {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FALLSCALE: {
      if (!defaultValues) return null;
      return <FallScale {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.GCS: {
      if (!defaultValues) return null;
      return <GCS {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.Pediatric_GCS: {
      if (!defaultValues) return null;
      return <Pediatric_GCS {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FourScore: {
      if (!defaultValues) return null;
      return <FourScore {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.Maturity: {
      if (!defaultValues) return null;
      return <Maturity {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SAFETY: {
      if (!defaultValues) return null;
      return <Safety {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.INFECTION: {
      if (!defaultValues) return null;
      return <Infection {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NRS: {
      if (!defaultValues) return null;
      return <NRS {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FLACC: {
      if (!defaultValues) return null;
      return <FLACC {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CNPS: {
      if (!defaultValues) return null;
      return <CNPS {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FFI: {
      if (!defaultValues) return null;
      return <FFI {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.KOOS: {
      if (!defaultValues) return null;
      return <KOOS {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.LEFS: {
      if (!defaultValues) return null;
      return <LEFS {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NDI: {
      if (!defaultValues) return null;
      return <NDI {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.STarT_BacknScreening: {
      if (!defaultValues) return null;
      return <STarTBackScreening {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.K_CPAT: {
      if (!defaultValues) return null;
      return <K_CPAT {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.PAINAD_K: {
      if (!defaultValues) return null;
      return <PAINAD_K_Commu {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.PAINAD_K_non: {
      if (!defaultValues) return null;
      return <PAINAD_K_non {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.MENTAL_NURSING: {
      if (!defaultValues) return null;
      return <MentalNursing {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.MSE: {
      if (!defaultValues) return null;
      return <MSE {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.BDI: {
      if (!defaultValues) return null;
      return <BDI {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.BAI: {
      if (!defaultValues) return null;
      return <BAI {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.MMSE: {
      if (!defaultValues) return null;
      return <MMSE {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CIST: {
      if (!defaultValues) return null;
      return <CIST {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.KDSQ_P: {
      if (!defaultValues) return null;
      return <KDSQ_P {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.KDSQ_C: {
      if (!defaultValues) return null;
      return <KDSQ_C {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.OPERATION: {
      if (!defaultValues) return null;
      return <Operation {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.ANESTHESIA: {
      if (!defaultValues) return null;
      return <Anesthesia {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.TRANSFUSION: {
      if (!defaultValues) return null;
      return <Transfusion {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.BLOODDISCHARGE: {
      if (!defaultValues) return null;
      return <BloodDischarge {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.RESTRAINT: {
      if (!defaultValues) return null;
      return <Restraint {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.INTUBATION: {
      if (!defaultValues) return null;
      return <Intubation {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.DIALYSIS: {
      if (!defaultValues) return null;
      return <Dialysis {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CPR: {
      if (!defaultValues) return null;
      return <CPR {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.EMERGENCY: {
      if (!defaultValues) return null;
      return <Emergency {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CHILDBIRTH: {
      if (!defaultValues) return null;
      return <Childbirth {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.HOME_CARE: {
      if (!defaultValues) return null;
      return <HomeCare {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.ECMO: {
      if (!defaultValues) return null;
      return <ECMO {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.RADIOLOGYETC: {
      if (!defaultValues) return null;
      return <RadiologyEtc {...dialogProps} onClose={onCloseReadOnly} />;
    }
    case MENU.KPCS: {
      if (!defaultValues) return null;
      return <KPCS {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.KPCSC: {
      if (!defaultValues) return null;
      return <KPCSC {...dialogProps} onClose={onCloseSave} />;
    }
    // case MENU.KPCSN: {
    //   if (!defaultValues) return null;
    //   return <KPCSN {...dialogProps} onClose={onCloseSave} />;
    // }
    case MENU.KPCS_GW: {
      if (!defaultValues) return null;
      return <KPCS_GW {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.KPCS_ICU: {
      if (!defaultValues) return null;
      return <KPCS_ICU {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NURSING_NEED: {
      if (!defaultValues) return null;
      return <NursingNeed {...dialogProps} onClose={onCloseSave} />;
    }
    // case MENU.KPCS_NICU: {
    //   if (!defaultValues) return null;
    //   return <KPCS_NICU {...dialogProps} onClose={onCloseSave} />;
    // }
    case MENU.DIET_NUTRITION: {
      if (!defaultValues) return null;
      return <DietList {...dialogProps} onClose={onCloseSave} />;
      // return <DietNutrition {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.HOSPITAL_CONFIRM: {
      if (!defaultValues) return null;
      return <HospitalizationInfo {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.ADMISSIN_AND_DISCHARGE: {
      if (!defaultValues) return null;
      return <AdmissionAndDischarge {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SELF_DISCHARGE: {
      if (!defaultValues) return null;
      return <SelfDischarge {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.FALL_CONFIRM: {
      if (!defaultValues) return null;
      return <FallPrevention {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.TRANSFUSIONAGREEMENT: {
      if (!defaultValues) return null;
      return <TransfusionAgreement {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CRRT_AGREEMENT: {
      if (!defaultValues) return null;
      return <CRRT {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CENTRALVENOUS: {
      if (!defaultValues) return null;
      return <CentralVenous {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.INTUBATIONAGREEMENT: {
      if (!defaultValues) return null;
      return <IntubationAgreement {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.COLONOSCOPY: {
      if (!defaultValues) return null;
      return <Colonoscopy {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.UPPER_ENDOSCOPY: {
      if (!defaultValues) return null;
      return <UpperEndoscopy {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SUPPRESSOR: {
      if (!defaultValues) return null;
      return <Suppressor {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NONSALARY: {
      if (!defaultValues) return null;
      return <NonSalary {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CONSENT_FOR_SURGERY: {
      if (!defaultValues) return null;
      return <ConsentForSurgery {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.MEDICALRECORDS: {
      if (!defaultValues) return null;
      return <MedicalRecords {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.DNR: {
      if (!defaultValues) return null;
      return <DNR {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.DNRTWO: {
      if (!defaultValues) return null;
      return <DNRTwo {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.DNA: {
      if (!defaultValues) return null;
      return <DNA {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.MINOR: {
      if (!defaultValues) return null;
      return <MinorConsent {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NURSING_PROCESS: {
      if (!defaultValues) return null;
      return <NursingRecord {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.DRUG_CALCULATOR: {
      if (!defaultValues) return null;
      return <DrugCalculatior {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.NURSE_CHECKLIST_ROOM: {
      if (!defaultValues) return null;
      return <NurseCheckListRoom {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SUBMIT_ASSIGNMENT: {
      if (!defaultValues) return null;
      return <SubmitAssignment {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CORE_NURSING_SKILL_VIDEO: {
      if (!defaultValues) return null;
      return <CoreNursingSkillVideo {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_ONE: {
      if (!defaultValues) return null;
      return (
        <CoreNursingSkillVideoExemple
          {...dialogProps}
          onClose={onCloseReadOnly}
        />
      );
    }
    case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_TWO: {
      if (!defaultValues) return null;
      return (
        <CoreNursingSkillVideoExempleTwo
          {...dialogProps}
          onClose={onCloseReadOnly}
        />
      );
    }
    case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_THREE: {
      if (!defaultValues) return null;
      return (
        <CoreNursingSkillVideoExempleThree
          {...dialogProps}
          onClose={onCloseReadOnly}
        />
      );
    }
    case MENU.CORE_NURSING_SKILL_VIDEO_EXEMPLE_FOUR: {
      if (!defaultValues) return null;
      return (
        <CoreNursingSkillVideoExempleFour
          {...dialogProps}
          onClose={onCloseReadOnly}
        />
      );
    }
    case MENU.VOICE_EMR: {
      if (!defaultValues) return null;
      return <VoiceEMR {...dialogProps} onClose={onCloseReadOnly} />;
    }

    case MENU.SIMUL_ACTIVITY_PLAN: {
      if (!defaultValues) return null;
      return <NursingActivityPlan {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SIMUL_PROCESS_RECORD: {
      if (!defaultValues) return null;
      return <ProcessRecord {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.SIMUL_PERSONAL_INFO_AGREEMENT: {
      if (!defaultValues) return null;
      return <PersonalAgreement {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.DEBRIEFING: {
      if (!defaultValues) return null;
      return <Debriefing {...dialogProps} onClose={onCloseSave} />;
    }
    case MENU.PATIENT_LABEL_PRINTING: {
      if (!defaultValues) return null;
      return <PatientLabel {...dialogProps} onClose={onCloseReadOnly} />;
    }
    default:
      return null;
  }
};

export default DisplaySurvey;
